export interface ProductColumn {
  key: string;
  label: string;
  sortable?: boolean;
  sortKey?: string;
}

export const productColumns: ProductColumn[] = [
  { key: "product", label: "Product", sortable: true, sortKey: "name" },
  { key: "position", label: "Position", sortable: true, sortKey: "position" },
  { key: "price", label: "Price", sortable: true, sortKey: "price" },
  { key: "marketPrice", label: "Market Price" },
  { key: "originalPrice", label: "Original Price" },
  { key: "category", label: "Category", sortable: true, sortKey: "category" },
  {
    key: "subCategory",
    label: "Sub Category",
    sortable: true,
    sortKey: "subCategory",
  },
  { key: "brand", label: "Brand", sortable: true, sortKey: "brand" },
  { key: "country", label: "Country", sortable: true, sortKey: "country" },
  { key: "supplier", label: "Supplier" },
  { key: "stock", label: "Stock" },
  { key: "linked", label: "Linked" },
  { key: "actions", label: "" },
];
